import React from 'react'

const ImageGrow = ({color}) => {

    return (
      <svg width="1074" height="1143" viewBox="0 0 1074 1143" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M536.547 934.011V933.973L385.123 849.35L412.51 729.032L536.547 678.931L660.47 729.032L687.896 849.35L536.547 934.011Z" fill="#2AD295"/>
      <path d="M270.998 622.931L202.454 530.103C168.031 560.087 136.445 591.66 102.589 622.25L171.738 747.446C187.172 728.275 202.681 709.18 218.153 690.009C236.045 667.852 253.408 645.316 270.998 622.931Z" fill="#2AD295"/>
      <path d="M466.036 404.112L536.585 446.31L607.058 403.28C605.205 393.184 603.918 383.996 603.048 375.526L788.745 292.528L658.769 180L536.585 198.566L414.893 180.945L284.123 293.247L470.046 376.32C469.176 384.79 467.852 393.978 466.036 404.074V404.112Z" fill="#2AD295"/>
      <path d="M130.392 425.288L39 503.785L85.982 588.862C118.741 559.331 151.802 530.14 185.091 501.176L130.392 425.288Z" fill="#2AD295"/>
      <path d="M260.973 518.078L394.278 675.3L536.548 617.864L678.78 675.3L812.085 518.078L782.163 439.958L894.247 383.845L824.946 323.838L633.916 413.944L651.355 462.872L536.51 538.572L421.665 462.91L439.104 413.944L248.339 323.989L178.698 383.808L290.857 439.996L260.973 518.078Z" fill="#2AD295"/>
      <path d="M289.759 661.348L195.795 786.581L293.618 964.789L349.754 729.598L295.282 654.012C293.391 656.394 291.575 658.852 289.797 661.348H289.759Z" fill="#2AD295"/>
      <path d="M802.06 622.931C819.649 645.316 837.012 667.852 854.905 690.009C870.376 709.18 885.886 728.275 901.32 747.446L970.469 622.25C936.613 591.66 905.027 560.05 870.603 530.103L802.06 622.931Z" fill="#2AD295"/>
      <path d="M942.703 425.288L888.004 501.176C921.293 530.102 954.354 559.331 987.113 588.862L1034.1 503.785L942.703 425.288Z" fill="#2AD295"/>
      <path d="M777.85 654.012L723.378 729.598L779.514 964.789L877.337 786.581L783.373 661.348C781.595 658.852 779.741 656.394 777.888 654.012H777.85Z" fill="#2AD295"/>
      </svg>
  )
}

const GrowLogo = ({color}) => {
  return (
    <ImageGrow color={color}/>
  )
}

export default GrowLogo